import React from 'react';
import { cn } from '../../helpers/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

interface ArrowLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  key?: React.Key;
  textClassName?: string;
}

const ArrowLink: React.FC<ArrowLinkProps> = ({ className, children, textClassName, ...props }) => {
  return (
    <a
      className={cn('group flex items-center no-underline', className)}
      {...props}
    >
      <FontAwesomeIcon icon={faArrowRight as IconProp} className="transition-transform duration-200 text-blue-500 group-hover:translate-x-2 mr-5" />
      <span className={cn('font-mulish font-bold text-blue-800 text-base md:text-lg group-hover:text-blue-600', textClassName)}>
        {children}
      </span>
    </a>
  );
};

export default ArrowLink;